import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore/lite';
import { db } from './firebaseConfig';
import {
  EARLY_ACCESS_NOTICE_VERSION,
  PRIVACY_VERSION,
  TERMS_VERSION,
} from './releaseState';

export const buildLegalAcceptance = () => ({
  termsVersion: TERMS_VERSION,
  privacyVersion: PRIVACY_VERSION,
  earlyAccessVersion: EARLY_ACCESS_NOTICE_VERSION,
  acceptedAt: serverTimestamp(),
});

export const buildEarlyAccessAcknowledgement = () => ({
  version: EARLY_ACCESS_NOTICE_VERSION,
  acknowledgedAt: serverTimestamp(),
});

export const getUserProfileRef = (uid) => doc(db, 'users', uid);

export async function loadUserProfile(uid) {
  if (!uid) return null;

  const snapshot = await getDoc(getUserProfileRef(uid));
  return snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
}

export async function upsertUserProfile(user, values = {}) {
  if (!user?.uid) return;

  await setDoc(
    getUserProfileRef(user.uid),
    {
      uid: user.uid,
      email: user.email || values.email || null,
      name: user.displayName || values.name || null,
      ...values,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}

export async function recordLegalAcceptance(user, { name, authProvider }) {
  await upsertUserProfile(user, {
    name: name || user.displayName || null,
    authProvider,
    legalAcceptance: buildLegalAcceptance(),
  });
}

export async function recordEarlyAccessAcknowledgement(uid) {
  if (!uid) return;

  await setDoc(
    getUserProfileRef(uid),
    {
      uid,
      earlyAccessAcknowledgement: buildEarlyAccessAcknowledgement(),
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}

export const needsEarlyAccessAcknowledgement = (profile) => (
  profile?.earlyAccessAcknowledgement?.version !== EARLY_ACCESS_NOTICE_VERSION
);
